<template>
    <div style="display:inline">
        <router-link to="/Login" v-if="!isLoggedIn">
          <el-button class="account-btn">{{'Login' | language}}</el-button>
        </router-link>

        <el-dropdown v-if="isLoggedIn">
            <el-button class="account-btn">
              {{user.username}}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="toProfile"><i class="fas fa-user"></i>{{'Account Settings' | language}}</el-dropdown-item>
                <el-dropdown-item @click.native="toFavorites"><i class="fas fa-star"></i>{{'Saved Properties' | language}}</el-dropdown-item>
                <el-dropdown-item @click.native="logout"><i class="fas fa-sign-out-alt"></i>{{'Logout' | language}}</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>

        <div v-if="isLoggedIn" class="account-menu-mobile">
            <p>{{'Welcome Back' | language}}, {{user.username}}</p>
            <ul>
                <li @click="toProfile"><i class="fas fa-user"></i>{{'Account Settings' | language}}</li>
                <li @click="toFavorites"><i class="fas fa-star"></i>{{'Saved Properties' | language}}</li>
                <li @click="logout"><i class="fas fa-sign-out-alt"></i>{{'Logout' | language}}</li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'auth',
  components: {
  },
  props:{
  },
   computed:{
    ...mapState({
      user: (state) => {
        return state.user.user
      }
    }),
    isLoggedIn() {
      return this.$store.getters['user/isLoggedIn']
    }
  },
  created(){
  },
  methods: {
      toHome() {
            this.$router.push({
                path: '/',
                query: {}
            })
        },
        logout(){
            this.$store.dispatch('user/logout')
            .then(() => {
                this.$router.push('/login')
            })
        },
        toProfile(){
          this.$router.push('/profile')
        },
        toFavorites(){
          this.$router.push('/favorites')
        }
  }
}
</script>

<style lang="scss">
  .header {
    background-color: rgb(255, 255, 255);
    padding: 0 10px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.3);

    &__navigation {
      padding: 1rem 0;
    }
    & a {
      color: #3d3d3d;
    }
  }

  .Header {
    &__BrandImage {
          cursor: pointer;
          padding-top: .3rem;
          width: 70vw;
          max-width: 375px;
          height: auto;
    }
  }

  .navigation {
    font-weight: 600;
    &__navitem {
      text-decoration: none;
      padding-right: 2rem;

      &:hover {
        text-decoration: none;
      }
    }
  }

  .el-button.account-btn {
    font-weight: 700;

    .el-icon-arrow-down {
      font-weight: 700;
    }
  }

  .el-dropdown-menu {
    padding: 0 !important;
    text-align: left;

    .el-dropdown-menu__item {
      font-weight: 600;
      padding: .25rem 1rem;
    }

    .fas {
      width: 30px;
    }
  }

</style>
